<template>
	<div>
		<LeftMenu :currentIndex="4" v-if="!showSecondPage"></LeftMenu>
		<div class="d-flex justify-content-between align-items-stretch">
			<div
				class="banner-item"
				v-for="(item, index) in imgList"
				:key="index"
				:class="[enlargeImgIndex === index ? 'active' : '', 'swiper-item-' + imgList.length]"
				@mouseover="enlargeImage(index)"
			>
				<img :src="item.imgSrc" class="imgItem" />
				<img :src="item.titleImg" class="titleItem" v-if="enlargeImgIndex===index" />
				<div class="overlay">
					<img :src="item.imgOverSrc" alt="">
				</div>
				<div class="moreBtn" v-if="enlargeImgIndex===index" @click="nextSecond(index)">
				</div>
			</div>
		</div>
		<ContactSecond v-if="showSecondPage" ></ContactSecond>
	</div>
</template>
<script>
import { eventBus } from '@/main.js'
export default {
	name: 'Contact',
	components: {
		ContactSecond: () => import('./ContactSecond.vue'),
		LeftMenu: () => import('../components/LeftMenu.vue')
	},
	props:{
		isShowBack:{
			type:Boolean
		},
		subActiveIndex:{
			type:Number,
			default: 0
		}
	},
	data() {
		return {
			showSecondPage: false, //子组件显示
			activeIndex: 0,
			enlargeImgIndex: 0,
			imgList: [{
					thumbImg: require("../../static/contact/swiper-img1-thumb.png"),
					imgOverSrc: require("../../static/contact/swiper-img1-over.png"),
					imgSrc: require("../../static/contact/swiper-img1.png"),
					titleImg: require("../../static/contact/swiper-img1-title.png"),
					// dImgSrc:require("../../static/p4-img1-d1.png")//了解更多详情大图
				},
				{
					thumbImg: require("../../static/contact/swiper-img2-thumb.png"),
					imgOverSrc: require("../../static/contact/swiper-img2-over.png"),
					imgSrc: require("../../static/contact/swiper-img2.png"),
					titleImg: require("../../static/contact/swiper-img2-title.png"),
				},
				{
					thumbImg: require("../../static/contact/swiper-img3-thumb.png"),
					imgOverSrc: require("../../static/contact/swiper-img3-over.png"),
					imgSrc: require("../../static/contact/swiper-img3.png"),
					titleImg: require("../../static/contact/swiper-img3-title.png"),
				}
			],
		}
	},
	methods: {
		enlargeImage(index) {
			if (this.enlargeImgIndex !== index) {
				// 展开当前图像
				this.enlargeImgIndex = index;
			}
		},
		resetImage() {
			// 恢复默认状态
			this.enlargeImgIndex = 0;
		},
		nextSecond(index) {
			this.$router.replace({path:'/contactSecond'+'/'+index})
			this.showSecondPage = true;
			this.$store.commit("setIsListening", false);
		}
	},
	watch:{
		// showSecondPage(val){
		// 	if(!this.showSecondPage){
		// 		console.log(this.$route.name)
		// 		// this.$router.replace({
		// 		// 	path: '/'+this.$route.name
		// 		// })
		// 	}
		// },
		subActiveIndex(val){
			if(val >= 0){
				this.enlargeImgIndex = val;
			}
		},
		isShowBack(val){
			if(!val){
				this.showSecondPage = false;
			}
		}
	},
	mounted(){
		//二级页面 返回
		eventBus.$on('backPrevMenu', (index) => {
			this.showSecondPage = false;
			this.$store.commit("setIsListening", true);
		});
	}
}
</script>
<style lang="less" scoped>
@import url('../assets/css/index.less');

.el-carousel__arrow {
	position: absolute;
	top: 90% !important;
	left: 50%;
}
.d-flex{
	display: flex;
}
.banner-item {
	position: relative;
	width: 421/@r;
	height: 967/@r;
	overflow: hidden;
	transition: all 0.5s ease-in-out;
	&.banner-item:nth-child(1) {
		.imgItem {
			object-position: left;
		}
	}
	&.banner-item:nth-child(2) {
		.imgItem {
			object-position: right;
		}
	}
	&.banner-item:nth-child(3) {
		.imgItem {
			object-position: right;
		}
	}
	&.banner-item:nth-child(4) {
		.imgItem {
			object-position: right;
		}
	}
	.imgItem {
		width: 100%;
		height: 967/@r;
		// height: 100%;
		object-fit: cover;
		object-position: left;
		filter: grayscale(1);
		opacity: 0.6;
	}
	.titleItem{
		width: 100%;
		height: 967/@r;
		.pos-a(0, 0, 2);
	}
	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 967/@r;
		background: rgba(255, 255, 255, 0.7);
		
		img {
			.scale(412,146) !important;
			.pos-a(0, 0, 4);
			top:18.8%;
		}
	}
	&.active {
		width: 841/@r;
		.imgItem {
			width: 100%;
			filter: none;
			opacity: 1;
		}
		.overlay {
			opacity: 0;
			transition: all 0.5s ease-in-out;
		}
	}
	.moreBtn {
		position: absolute;
		top: 38.3%;
		left: 16.1%;
		z-index: 3;
		.scale(159, 45) !important;
		img {
			width: 100%;
			display: inline-block;
		}
	}
	// &:first-child {
	// 	.moreBtn {
	// 		position: absolute;
	// 		left: 81.6%;
	// 		top: 36%;
	// 		z-index: 3;
	// 	}
	// }
}
@keyframes fadenum {
	0% {
		width: 421 / @r;
	}
	100% {
		width: 841 / @r !important;
	}
}
</style>

